import {ContractInfo, ContractInfoJson, getMethod} from './BucketMemberInfoDTO'
import {Nullable} from '../../../../Common/TypeHelper'
import {Contract} from '../../../Utils/Resources'

export type ContractHistoryJSON = ContractInfoJson

export type ContractHistory = ContractInfo

export class ContractHistoryDTO implements ContractHistory {
  executionDate: string
  sourceType: Contract.SourceTypeType
  status: Contract.StatusType
  bucketId: number
  bucketKey: string
  bucketName: string
  bucketMemberId: Nullable<string>
  amount: number
  startDate: string
  endDate: string
  term: string
  contractMethod: ContractInfo['contractMethod']
  contractType: Contract.ContractTypeType
  mainContractId: string
  contractId: string
  gmoOrderId: Nullable<string>

  constructor(
    executionDate: string,
    sourceType: Contract.SourceTypeType,
    status: Contract.StatusType,
    bucketId: number,
    bucketKey: string,
    bucketName: string,
    bucketMemberId: Nullable<string>,
    amount: number,
    startDate: string,
    endDate: string,
    term: string,
    contractMethod: ContractInfo['contractMethod'],
    contractType: Contract.ContractTypeType,
    mainContractId: string,
    contractId: string,
    gmoOrderId: Nullable<string>,
  ) {
    this.executionDate = executionDate
    this.sourceType = sourceType
    this.status = status
    this.bucketId = bucketId
    this.bucketKey = bucketKey
    this.bucketName = bucketName
    this.bucketMemberId = bucketMemberId
    this.amount = amount
    this.startDate = startDate
    this.endDate = endDate
    this.term = term
    this.contractMethod = contractMethod
    this.contractType = contractType
    this.mainContractId = mainContractId
    this.contractId = contractId
    this.gmoOrderId = gmoOrderId
  }

  static fromJSON(jsonObject: ContractHistoryJSON): ContractHistoryDTO {
    return new ContractHistoryDTO(
      jsonObject.executionDate,
      jsonObject.sourceType,
      jsonObject.status,
      jsonObject.bucketId,
      jsonObject.bucketKey,
      jsonObject.bucketName,
      jsonObject.bucketMemberId,
      jsonObject.amount,
      jsonObject.startDate,
      jsonObject.endDate,
      jsonObject.term,
      getMethod(jsonObject.method, jsonObject.paymentMethodDetail),
      jsonObject.type,
      jsonObject.mainContractId,
      jsonObject.contractId,
      jsonObject.gmoOrderId,
    )
  }
}
